import produce from 'immer'
import { isNotEmptyElement } from '@feedyou/utils'
import { PromptStepSchema } from '@feedyou-ai/feedbot-schema'

import { GetUsedDialogs } from '../../../types'

export const getUsedDialogs: GetUsedDialogs<PromptStepSchema> = (
  { validator, disabled, answers, defaultAnswer },
  enabledOnly = false
) => {
  if (enabledOnly && disabled) {
    return []
  }

  return produce([] as string[], result => {
    if (validator && validator.type && validator?.type !== 'none') {
      result.push(...[validator.validDialog, validator.invalidDialog].filter(isNotEmptyElement))
    }

    answers?.forEach(answer => {
      if (answer.dialog && Boolean(!enabledOnly || !answer.disabled)) {
        result.push(answer.dialog)
      }
    })

    if (defaultAnswer?.dialog && Boolean(!enabledOnly || !defaultAnswer.disabled)) {
      result.push(defaultAnswer?.dialog)
    }
  })
}
